import React from "react";
import { connect } from "react-redux";

import "./Inactive.css";

import history from "../../history";
import { startActivation } from "../../actions/userActions";

import Modal from "../CustomViews/Modal";

class Inactive extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            render: false
        };
    }

    componentDidMount() {
        if (this.props.currentUser.active === 1) history.push("/");
        else if (this.props.currentUser.active === 0) this.setState({ render: true });
    }

    componentDidUpdate() {
        if (this.props.currentUser.active === 1) history.push("/");
        else if (!this.state.render) this.setState({ render: true });
    }

    renderModal = () => {
        if (this.state.modal) {
            return (
                <Modal
                    title="Wysłano link aktywacyjny"
                    content={<p>Na adres <b>{this.props.currentUser.email}</b> wysłany został link aktywacyjny.<br />Kliknij ten link, aby aktywować konto.</p>}
                    actions={<button onClick={() => history.go(0)} className="ui button">OK</button>}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    onActivateClick = () => this.props.startActivation(() => this.setState({ modal: true }));

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="inactive-component ui container">
                        <div className="ui container">
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="exclamation triangle icon"></i>
                                        <div className="header">Twoje konto nie jest aktywne</div>
                                    </h2>
                                </div>
                            </div>
                            <div className="ui divider" />
                            <h3 className="header">Aby skorzystać z tej funkcji musisz aktywować konto</h3>
                            <div className="content">Naciśnij przycisk poniżej, aby otrzymać link aktywacyjny</div>
                            <div className="content">
                                <button className="ui button" type="button" onClick={this.onActivateClick}>Wyślij link</button>
                            </div>
                        </div>
                    </div>
                    {this.renderModal()}
                </React.Fragment>
            );
        }
        else return null;
    }
}

const mapStateToProps = state => ({ currentUser: state.user.current });

export default connect(mapStateToProps, { startActivation })(Inactive);